<template>
  <a-modal :width="600" :visible="visible" :wrap-class-name="$style.modalSync" :closable="false">
    <div class="w-100 text-center">
      <img
        class="image-spin"
        src="@/assets/images/work-in-progress.png"
        width="100"
        heigh="100"
        height="auto"
      />
    </div>
    <h4 class="text-center">
      Mohon menunggu
    </h4>
    <h4 class="text-center">
      Proses export data sedang berlangsung
    </h4>
    <h6 class="text-center mt-4">
      Anda dapat menutup informasi ini dan file akan otomatis terunduh di
      <router-link
        :to="{
          path: '/export-history',
          query: { workspace_id: $route.query.workspace_id, business_id: businessId }
        }"
      >
        menu history data
      </router-link>
    </h6>
    <template #footer>
      <a-button @click.prevent="onMinimizeNotification">
        Tutup
      </a-button>
    </template>
  </a-modal>
</template>


<script>

import getQueryParam from '@/utils/getQueryParam'

export default{
    name: 'ModalNotificationExport',
    components:{
    },
    props:{
    },
    data() {
    return {
      visible: false,
    }
  },
  computed: {
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
  },
  watch: {
    // comment old export sales
    // '$store.state.exportData.showModalExportSales': {
    //   deep: true,
    //   immediate: true,
    //   handler: function (value) {
    //     this.visible = value
    //   },
    // },
    // $route() {
    //   this.visible = false

    //   this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
    //     showModalExportSales: false,
    //     exportFileNotification: false,
    //   })
    // },
  },
  methods: {
    onMinimizeNotification() {
      this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
        showModalExportSales: false,
        exportFileNotification: false,
      })
    },
  },
}
</script>


<style lang="scss" module>
// @import './style.module.scss';
</style>
<style lang="scss">
.image-spin {
  -webkit-animation:spin 4s linear infinite;
  -moz-animation:spin 4s linear infinite;
  animation:spin 4s linear infinite;
}
@-moz-keyframes spin { 
    100% { -moz-transform: rotate(360deg); } 
}
@-webkit-keyframes spin { 
    100% { -webkit-transform: rotate(360deg); } 
}
@keyframes spin { 
    100% { 
        -webkit-transform: rotate(360deg); 
        transform:rotate(360deg); 
    } 
}
</style>